import { render, staticRenderFns } from "./MisspellItem.vue?vue&type=template&id=82fff8da&scoped=true&"
import script from "./MisspellItem.vue?vue&type=script&lang=js&"
export * from "./MisspellItem.vue?vue&type=script&lang=js&"
import style0 from "./MisspellItem.vue?vue&type=style&index=0&id=82fff8da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fff8da",
  null
  
)

export default component.exports